import { apiSlice } from "../api/apiSlice";

export const dashboardDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    weatherDetailsDashboared: builder.mutation({
      query: (data) => ({
        url: "/apiV2/weather-sensor-dashboard",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useWeatherDetailsDashboaredMutation } = dashboardDetailsApi;
